<script setup lang="ts">
defineOptions({
  name: 'PaymentSettingsIndex',
})

import { computed } from 'vue'
import { getPaymentSettingsAction } from '@/api/functions/settings/payment-settings-action'
import { useQueryApi } from '@/composables/useApi'
import { settingsTabs } from '@/constants/setting-tabs.ts'
import SettingsOverview from '../partials/SettingsOverview.vue'
import PaymentSettingCard from './partials/UpdatePaymentSettingModal.vue'

const { data: settingsData, refetch: refetchSettings } = useQueryApi({
  queryKey: ['payment-settings'],
  queryFn: () => getPaymentSettingsAction(),
})

const paymentSettings = computed(() => settingsData.value?.data || [])
const handleUpdated = () => {
  refetchSettings()
}
</script>

<template>
  <div class="w-full mb-12">
    <SettingsOverview :tabs="settingsTabs" />

    <div class="mt-20 lg:mt-7 grid grid-cols-1 sm:grid-cols-2 2xl:grid-cols-4 gap-4">

      <PaymentSettingCard v-for="setting in paymentSettings" :key="setting.id" :setting="setting"
        :all-settings="paymentSettings" @updated="handleUpdated" />

    </div>
  </div>
</template>
